import { BlurEvent, DataSourceExecutionEvent, DataSourceMode, DropdownSelectionEvent, EditRowDecorator, Layout, LookupModelSearchEvent, LookupModelSelectionEvent, Textbox } from "@mcleod/components";
import { AutogenLayoutCarrierAction } from "@mcleod/crm/src/autogen/AutogenLayoutCarrierAction";
import { Api, ModelRow, StringUtil } from "@mcleod/core";
import { ModelCarrierObjection } from "./models/ModelCarrierObjection";
import { EditRowDecoratorProps } from "@mcleod/components/src/page/decorators/EditRowDecoratorProps";

export class CarrierAction extends AutogenLayoutCarrierAction {

    private _contactFilter;

    sourceCarrierActionAfterExecution(event: DataSourceExecutionEvent) {
        if (this.activeRow) {
            if (!this.activeRow.isNull("primary_contact")) {
                this.activeRow.setLookupModelData("primary_contact", { "name": this.activeRow.getString("primary_contact") });
                this.mainDataSource.displayDataInBoundComponent(this.textboxPrimaryContact);
            }
            if (!this.activeRow.isNull("objection_id1")) {
                this.findAndSetObjectionValues("objection_id1", this.textboxObjection1Script);
            }
            if (!this.activeRow.isNull("objection_id2")) {
                this.findAndSetObjectionValues("objection_id2", this.textboxObjection2Script);
            }
        }
    }

    textboxActivityIdOnLookupModelSelection(event: LookupModelSelectionEvent) {
        if (event.hasSelection()) {
            this.activeRow.set("descr", event.selection.getString("descr", null));
            this.mainDataSource.displayDataInBoundComponent(this.textboxDescr);
        } else if (event.hasDeselection()) {
            this.textboxDescr.clear();
        }
    }

    textboxPrimaryContactBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        if (this.activeRow.isNull("carrier_id")) {
            event.preventDefault();
            return;
        }
    }

    textboxCarrierIdOnLookupModelSelection(event: LookupModelSelectionEvent) {
        if (event.hasSelection()) {
            const carrier = event.selection;
            this.initializeContactFilter(carrier.getString("payee_id"));

            this.activeRow.setValueAndLookupModelData(
                "primary_contact",
                carrier.getString('contact.name', null),
                { "name": carrier.getString('contact.name', null) }
            );
            this.mainDataSource.displayDataInBoundComponent(this.textboxPrimaryContact);
            this.activeRow.setValues({
                "phone": carrier.getString('contact.phone', null),
                "email": carrier.getString('contact.email', null)
            });
            this.mainDataSource.displayDataInBoundComponent(this.textboxPhone);
            this.mainDataSource.displayDataInBoundComponent(this.textboxEmail);

            if (!carrier.isNull("carrier_mgr")) {
                this.activeRow.setValueAndLookupModelData(this.textboxOperationsUser.field, carrier.getString("carrier_mgr"), carrier.getLookupModelData("carrier_mgr"));
                this.mainDataSource.displayDataInBoundComponent(this.textboxOperationsUser);
            }
            if (!carrier.isNull("salesperson_id")) {
                this.activeRow.setValueAndLookupModelData(this.textboxSalespersonId.field, carrier.getString("salesperson_id"), carrier.getLookupModelData("salesperson_id"));
                this.mainDataSource.displayDataInBoundComponent(this.textboxSalespersonId);
            }
        } else if (event.hasDeselection()) {
            this.removeContactSearchListenerIfNeeded();
            this.textboxPrimaryContact.clear();
            this.textboxPhone.clear();
            this.textboxEmail.clear();
        }
    }

    textboxPrimaryContactOnLookupModelSelection(event: LookupModelSelectionEvent) {
        if (event.hasSelection()) {
            const contact = event.selection;
            this.activeRow.setValues({
                "phone": contact.getString('phone', null),
                "email": contact.getString('email', null)
            });
            this.mainDataSource.displayDataInBoundComponent(this.textboxPhone);
            this.mainDataSource.displayDataInBoundComponent(this.textboxEmail);
        } else if (event.hasDeselection()) {
            this.textboxPhone.clear();
            this.textboxEmail.clear();
        }
    }

    textboxStatusAfterDropdownSelection(event: DropdownSelectionEvent) {
        if ("P" === event.selection.value){
            this.activeRow.set("action_date", null);
        } else {
            this.activeRow.set("action_date", new Date());
        }
    }

    textboxObjectionId1OnLookupModelSelection(event: LookupModelSelectionEvent) {
        this.textboxObjection1Script.text = event.hasSelection() ? event.getValueFromSelectedRow("response_script") : null;
    }

    textboxObjectionId2OnLookupModelSelection(event: LookupModelSelectionEvent) {
        this.textboxObjection2Script.text = event.hasSelection() ? event.getValueFromSelectedRow("response_script") : null;
    }

    carrierTypeSearchFilter(event: LookupModelSearchEvent) {
        event.filter.type_of = "A";
    }

    notReccallSearchFilter(event: LookupModelSearchEvent) {
        event.filter.id = "!RECCALL";
    }

    carrierActivityIdSearchFilter(event: LookupModelSearchEvent) {
        this.carrierTypeSearchFilter(event);
        this.notReccallSearchFilter(event);
    }

    textboxActivityIdBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        this.carrierActivityIdSearchFilter(event);
    }

    textboxNextActIdBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        this.carrierActivityIdSearchFilter(event);
    }

    async textboxNextActionAfterDropdownSelection(event: DropdownSelectionEvent) {
        await this.syncNextActivity();
        if (event.hasSelection()) {
            this.textboxNextActId.required = true;
            this.textboxNextActDate.required = true;
            switch (event.selection.value) {
                case "A":
                    this.activeRow.setValues({
                        "next_act_id": null,
                        "next_act_date": null
                    });
                    this.textboxNextActId.clear();
                    this.textboxNextActDate.clear();
                    this.textboxNextActId.enabled = true;
                    this.textboxNextActDate.enabled = true;
                    break;
                case "U":
                    this.textboxNextActId.enabled = false;
                    this.textboxNextActDate.enabled = true;
                    break;
            }
        } else if (event.hasDeselection()) {
            this.textboxNextActId.enabled = this.textboxNextActId.required = false;
            this.textboxNextActDate.enabled = this.textboxNextActDate.required = false;
        }
    }

    private findAndSetObjectionValues(targetField: string, targetComponent: Textbox) {
        const objectionId = this.activeRow.getString(targetField);
        new ModelCarrierObjection().searchSingle({ id: objectionId, "type_of": "A" })
            .then((modelRow: ModelRow) => {
                this.activeRow.setLookupModelData(targetField, modelRow);
                targetComponent.text = modelRow.getString("response_script");
                this.mainDataSource.displayDataInBoundComponents();
            })
    }

    initializeContactFilter(carrierId: string) {
        this.removeContactSearchListenerIfNeeded();
        this._contactFilter = (event: LookupModelSearchEvent) => {
            event.filter.is_active = 'Y';
            event.filter.parent_row_type = 'P';
            event.filter.parent_row_id = carrierId;
        };
        this.textboxPrimaryContact.addBeforeLookupModelSearchListener(this._contactFilter);
    }

    private removeContactSearchListenerIfNeeded() {
        if (this._contactFilter) {
            this.textboxPrimaryContact.removeBeforeLookupModelSearchListener(this._contactFilter);
        }
    }

    static showAddActionSlideout(defaults: Partial<any>, props?: Partial<EditRowDecoratorProps>) {
        const carrierActionLayout = Layout.getLayout("lme/crm/CarrierAction") as CarrierAction;

        const decorator = new EditRowDecorator({
            layout: carrierActionLayout,
            title: "Add Carrier Action",
            fillHeight: true,
            layoutLoadListeners: [(_) => carrierActionLayout.mainDataSource.createBlankRow().then(row => {
                carrierActionLayout.mainDataSource.setRowsAndMode(DataSourceMode.ADD, [row]);
                carrierActionLayout.activeRow.setValues(defaults);
                carrierActionLayout.syncNextActivity();
                decorator.data = carrierActionLayout.activeRow;
            })],
            ...props
        });
    }

    textboxDateDueOnBlur(event: BlurEvent) {
        if (event.changedWhileFocused) {
            this.syncNextActivity();
        }
    }

    textboxCarrierIdOnBlur(event: BlurEvent) {
        if (event.changedWhileFocused) {
            this.syncNextActivity();
        }
    }

    syncNextActivity() {
        const actionId = this.activeRow.getString("id", null);
        const carrierId = this.activeRow.getString("carrier_id", null);
        const dateDue = this.activeRow.getDate("date_due", null);
        return CarrierAction.findNextActivity(actionId, carrierId, dateDue).then((nextActivity) => {
            if (nextActivity.id) {
                this.activeRow.setValueAndLookupModelData("next_act_id", nextActivity.id, { "id": nextActivity.id, "descr": nextActivity.descr });
                this.activeRow.set("next_act_date", nextActivity.date_due);
            } else {
                this.activeRow.setValues({
                    "next_act_id": null,
                    "next_act_date": null
                });
            }
            this.textboxNextActId.displayComponentData(this.activeRow, null, 0);
            this.textboxActionDate.displayComponentData(this.activeRow, null, 0);
        });
    }

    static findNextActivity(actionId:string, carrierId: string, dateDue: Date): Promise<{id: string, descr: string, date_due: Date}> {
        if (StringUtil.isEmptyString(carrierId) || !dateDue) {
            return Promise.resolve({id: null, descr: null, date_due: null});
        }
        return Api.post("lme/crm/next-activity", {
            "action_id": actionId,
            "carrier_id": carrierId,
            "date_due": dateDue
        }).then((response) => {
            if (response.data && response.data.length > 0) {
                return {
                    id: response.data[0].activity_id,
                    descr: response.data[0].descr,
                    date_due: new Date(response.data[0].date_due)
                };
            }
            return {id: null, descr: null, date_due: null};
        });
    }

    static showEditActionSlideout(modelRow: ModelRow<any>, props?: Partial<EditRowDecoratorProps>) {
        const carrierActionId = modelRow.get("prospect_action_id", modelRow.get("id", null)) as string;
        if (StringUtil.isEmptyString(carrierActionId)) {
            throw new Error("Carrier Action ID is required to edit an action.");
        }
        const carrierActionLayout = Layout.getLayout("lme/crm/CarrierAction") as CarrierAction;
        const decorator = new EditRowDecorator({
            layout: carrierActionLayout,
            title: "Edit Carrier Action",
            fillHeight: true,
            layoutLoadListeners: [(_) => carrierActionLayout.search({ id: carrierActionId }).then(() => {
                decorator.btnDelete.visible = "C" !== carrierActionLayout.activeRow.getString("status", null);
                if (carrierActionLayout.activeRow.isNull("action_date")) {
                    carrierActionLayout.activeRow.set("status", "C");
                    carrierActionLayout.activeRow.set("action_date", new Date());
                }
                carrierActionLayout.initializeContactFilter(modelRow.getString("carrier_id"));
                decorator.dataSource = carrierActionLayout.mainDataSource;
                decorator.data = carrierActionLayout.activeRow;
                carrierActionLayout.syncNextActivity();
            })],
            ...props,
            onDelete: () => {
                decorator.slideOut();
                decorator.data.delete().then(() => {
                    if (props?.onDelete){
                        props.onDelete();
                }
                })
            }
        });
    }
}
